import { withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';

const styles = theme => ({
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    background: '#FFFFFF22',
    padding: 16,
    borderRadius: 5,
  },

  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // paddingTop: 5,
  },

  icon: {
    marginRight: 16,
    color: 'var(--self-inspect-text-color)',
  },
});

const SelfInspectInfoBox = withStyles(styles)(({ classes, className, style, children }) => {
  return (
    <div
      //
      className={classNames(classes.labelContainer, className)}
      style={style}
    >
      <div className={classes.iconContainer}>
        <InfoIcon className={classes.icon} />
      </div>

      <SelfInspectQuestionLabel>{children}</SelfInspectQuestionLabel>
    </div>
  );
});

export default SelfInspectInfoBox;
